var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import { saveData } from '../../utils/storage';
import moment from 'moment';
import { contractBoardName, leaseMode as leaseModes, signStatus as signStatusArr, } from '../../constant/common-type';
import commonBaseInfo from '../../components/console-common/common-base-info.vue';
export default Vue.extend({
    created: function () { },
    components: {
        'el-base-info': commonBaseInfo,
    },
    data: function () {
        return {
            baseInfoList: [],
            contractInfoList: [],
            transactorInfoList: [],
            remarkInfoList: [],
        };
    },
    computed: __assign({}, mapState({
        contract: 'contract',
    }), { contractDetail: function () {
            return this.contract.contractDetail;
        } }),
    methods: {
        getBaseInfoList: function () {
            var _a = this.contractDetail, contractCode = _a.contractCode, cityName = _a.cityName, driverName = _a.driverName, driverIdNo = _a.driverIdNo, driverContact = _a.driverContact, driverMobile = _a.driverMobile, plateNumber = _a.plateNumber, activeState = _a.activeState;
            this.baseInfoList = [];
            this.baseInfoList = Object.assign(this.baseInfoList, [
                {
                    label: '合同号',
                    val: contractCode,
                },
                {
                    label: '城市',
                    val: cityName,
                },
                {
                    label: '司机姓名',
                    val: driverName,
                },
                {
                    label: '司机身份证号',
                    val: driverIdNo,
                },
                {
                    label: '司机联系方式',
                    val: driverContact,
                },
                {
                    label: '司机手机号',
                    val: driverMobile,
                },
                {
                    label: '车牌号',
                    val: plateNumber,
                },
                {
                    label: '合同状态',
                    val: contractBoardName[activeState],
                },
            ]);
        },
        getContractInfoList: function () {
            var _this = this;
            var _a = this.contractDetail, settlementCompanyName = _a.settlementCompanyName, signCompanyName = _a.signCompanyName, leaseMode = _a.leaseMode, totalDuration = _a.totalDuration, runMode = _a.runMode, cooperationMode = _a.cooperationMode, tenantName = _a.tenantName, driverName = _a.driverName, driverIdNo = _a.driverIdNo, totalAmountUpperText = _a.totalAmountUpperText, contractCode = _a.contractCode, signStatus = _a.signStatus;
            var _b = this.contractDetail, startTime = _b.startTime, endTime = _b.endTime, repayStartTime = _b.repayStartTime, repayEndTime = _b.repayEndTime, createTime = _b.createTime, totalAmount = _b.totalAmount, monthlyPayment = _b.monthlyPayment, guaranteeDeposit = _b.guaranteeDeposit, downPayment = _b.downPayment, tailPayment = _b.tailPayment, plateNumber = _b.plateNumber;
            startTime = startTime ? moment(startTime).format('YYYY-MM-DD') : '';
            endTime = endTime ? moment(endTime).format('YYYY-MM-DD') : '';
            repayStartTime = repayStartTime
                ? moment(repayStartTime).format('YYYY-MM-DD')
                : '';
            repayEndTime = repayEndTime
                ? moment(repayEndTime).format('YYYY-MM-DD')
                : '';
            createTime = createTime ? moment(createTime).format('YYYY-MM-DD') : '';
            totalAmount = this.$utils.toYuan(totalAmount);
            monthlyPayment = this.$utils.toYuan(monthlyPayment);
            guaranteeDeposit = guaranteeDeposit
                ? this.$utils.toYuan(guaranteeDeposit)
                : '';
            downPayment = downPayment ? this.$utils.toYuan(downPayment) : '';
            tailPayment = tailPayment ? this.$utils.toYuan(tailPayment) : '';
            this.contractInfoList = [];
            this.contractInfoList = Object.assign(this.contractInfoList, [
                {
                    label: '合同有效期',
                    val: startTime + " \u81F3 " + endTime,
                },
                {
                    label: '还款有效期',
                    val: repayStartTime + " \u81F3 " + repayEndTime,
                },
                {
                    label: '结算公司',
                    val: settlementCompanyName,
                },
                {
                    label: '所属公司',
                    val: signCompanyName,
                },
                {
                    label: '业务模式',
                    val: leaseModes[leaseMode],
                },
                {
                    label: '期数',
                    val: totalDuration,
                },
                {
                    label: '',
                    val: monthlyPayment,
                },
                {
                    label: '',
                    val: totalAmount,
                },
                {
                    label: '保证金',
                    val: guaranteeDeposit,
                },
                {
                    label: '',
                    val: downPayment,
                },
                {
                    label: '尾款',
                    val: tailPayment,
                },
                // {
                //   label: '班次',
                //   val: runModes[runMode],
                // },
                // {
                //   label: '合作模式',
                //   val: cooperationModes[cooperationMode],
                // },
                {
                    label: '余额代扣协议',
                    val: signStatusArr[signStatus],
                    isUseBtn: signStatus === 'UNSIGN' || signStatus === 'SIGNED',
                    btnTxt: '查看',
                    callback: function () {
                        saveData('agreement', {
                            tenantName: tenantName,
                            startTime: startTime,
                            endTime: endTime,
                            createTime: createTime,
                            driverName: driverName,
                            driverIdNo: driverIdNo,
                            totalAmount: totalAmount,
                            totalAmountUpperText: totalAmountUpperText,
                            contractCode: contractCode,
                            plateNumber: plateNumber,
                        });
                        var href = _this.$router.resolve({
                            name: 'contractAgreement',
                        }).href;
                        window.open(href, '_blank');
                    },
                },
            ]);
            if (leaseMode === 'JINGZU') {
                this.contractInfoList[6].label = '月租金';
                this.contractInfoList[7].label = '总租金';
                this.contractInfoList[9].label = '押金';
                this.contractInfoList.splice(10, 1);
                return;
            }
            if (leaseMode === 'RONGZU') {
                this.contractInfoList[6].label = '月供';
                this.contractInfoList[7].label = '总额';
                this.contractInfoList[9].label = '首付';
            }
        },
        getTransactorInfoList: function () {
            var _a = this.contractDetail, transactorContract = _a.transactorContract, transactorManager = _a.transactorManager, transactorSale = _a.transactorSale;
            this.transactorInfoList = [];
            this.transactorInfoList = Object.assign(this.transactorInfoList, [
                {
                    label: '合同经办人',
                    val: transactorContract,
                },
                {
                    label: '司管',
                    val: transactorManager,
                },
                {
                    label: '销售',
                    val: transactorSale,
                },
            ]);
        },
        getRemarkInfoList: function () {
            var note = this.contractDetail.note;
            this.remarkInfoList = [];
            this.remarkInfoList = Object.assign(this.remarkInfoList, [
                {
                    label: '备注',
                    val: note,
                },
            ]);
        },
    },
    watch: {
        contractDetail: function () {
            this.getBaseInfoList();
            this.getContractInfoList();
            this.getTransactorInfoList();
            this.getRemarkInfoList();
        },
    },
});
